"use client"

import * as React from "react"
// shadcn-uiのCard周りのコンポーネントをimport
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card"

import { Eye, EyeOff } from "lucide-react"

export function HideUsageGuide() {
  return (
    <Card className="my-6 w-full max-w-2xl bg-card">
      <CardHeader>
        <CardTitle>暗記機能のご案内</CardTitle>
        <CardDescription>
          <p className="text-sm text-muted-foreground">
            <span className="inline-flex items-center gap-1">
              ???
              <Eye className="w-4 h-4" />
              または
              <EyeOff className="w-4 h-4" />
            </span>
            のアイコンをクリックして、テキストを隠す/表示することができます。
          </p>
        </CardDescription>
      </CardHeader>
    </Card>
  )
}
